import { FilterMultiSelect, SearchField } from "@/modules/common";
import { EventOrderStatus } from '@/modules/eventsV2/types';

import {
  type EventFiltersType,
  type FiltersChangeType,
  ChangeTypes
} from "@/modules/eventsV2/hooks";

const statusOptions = [
  { value: 'New', id: EventOrderStatus.New },
  { value: 'Pending', id: EventOrderStatus.Pending },
  { value: 'Printing', id: EventOrderStatus.Printing },
  { value: 'Completed', id: EventOrderStatus.Completed },
  { value: 'Canceled', id: EventOrderStatus.Canceled },
  { value: 'Failed', id: EventOrderStatus.Failed },
];

export const OrdersFilters = ({
  filters,
  onFilters,
}: {
  filters: EventFiltersType;
  onFilters: FiltersChangeType;
}) => {
  return (
    <div className="flex gap-4 w-full">
      <SearchField
        placeholder="Search by name or phone"
        defaultValue={filters.search || ''}
        className="w-full max-w-[250px]"
        onChange={(value) => onFilters({ search: value }, ChangeTypes.Debounce)}
      />

      <FilterMultiSelect
        options={statusOptions}
        label="Status"
        values={filters.statuses || []}
        onChange={(value: EventOrderStatus[]) => onFilters({ statuses: value })}
      />
    </div>
  );
};
